import { id } from '@swimlane/ngx-datatable';
import { FireBatchStatus } from '@up/data';

export class FireBatchShortDto {
  id: number;
  fireId: string;
  status: FireBatchStatus;
  businessEntityId: number;
  businessEntityBankId?: number;
}
